module.exports = __webpack_public_path__ + "img/right_worm_n1_2.prt.323e7c54.jpg";